// Copyright 2025, University of Maryland, All Rights Reserved
import type { FC } from 'react'
import { Label, Input } from '@/components/ui'
import type { DatasourceConfigProps, OriginalDocumentDatasourceSettings } from '../types'

/**
 * Configuration form for OriginalDocument datasource.
 * Workspace override only - used by text extraction nodes.
 */
export const OriginalDocumentConfig: FC<DatasourceConfigProps<OriginalDocumentDatasourceSettings>> = ({
  config,
  onChange,
}) => {
  const sourceOrgId = config?.sourceOrgId ?? ''
  const sourceWsId = config?.sourceWsId ?? ''

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="source-org-id">Source Organization ID</Label>
        <p className="text-xs text-muted-foreground">
          Fetch documents from a different organization. Leave empty to use current org.
        </p>
        <Input
          id="source-org-id"
          value={sourceOrgId}
          onChange={(e) => onChange('sourceOrgId', e.target.value || null)}
          placeholder="Current organization"
          className="w-48"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="source-ws-id">Source Workspace ID</Label>
        <p className="text-xs text-muted-foreground">
          Fetch documents from a different workspace. Leave empty to use current workspace.
        </p>
        <Input
          id="source-ws-id"
          value={sourceWsId}
          onChange={(e) => onChange('sourceWsId', e.target.value || null)}
          placeholder="Current workspace"
          className="w-48"
        />
      </div>
    </div>
  )
}
